<!--
 * @Description: 学生 详情 基本信息
 * @Author: PF
 * @Date: 2023-03-08 10:33:25.239
 * @LastEditors: PF
 * @LastEditTime: 2025-07-16 17:55:26
-->
<template>
  <div class="hp100" v-loading="loading">
    <el-container>
      <el-main>
        <el-form :model="userInfo" label-position="right" label-width="140px" inline-message>
          <!-- zdlx 类型：[1]单行文本 [2]多行文本 [3]数字 [4]下拉框 [5]级联下拉框 [6]单选 [7]多选 [8]日期 [9]日期区间 [99]自定义标签 -->
          <table class="biao_ge wp100" border="0">
          <tr v-for="(item, index) in bgData" :key="index">
            <td v-for="(ite, ind) in item" :key="ind" :colspan="ite.lzws" :style="lie===2?'width: 50% !important;':lie===3?'width: 33.3% !important;':lie===4?'width: 25% !important;':'width: 100% !important;'" >
                <div v-if="ite.zdlx === 99">
                  <el-divider content-position="left">
                    <h1 class="biao_ti">{{ite.zdzwmc}}</h1>
                  </el-divider>
                </div>
                <div v-else-if="ite.zdlx === 1">
                  <el-form-item v-if="ite.zdmc==='XH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XM'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xm}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='YWXM'" :label="ite.zdzwmc+'：'">
                    {{userInfo.ywxm}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XMPY'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xmpy}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='CYM'" :label="ite.zdzwmc+'：'">
                    {{userInfo.cym}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SFZJH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.sfzjh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JG'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jg}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='TC'" :label="ite.zdzwmc+'：'">
                    {{userInfo.tc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XSLXDH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xslxdh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='WLDZ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.wldz}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JSTXH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jstxh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='DZXX'" :label="ite.zdzwmc+'：'">
                    {{userInfo.dzxx}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XJH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xjh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SZBJ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.szbj}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='YXXMC'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.yxxmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='YXH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.yxh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZSBH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.zsbh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTZZ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtzz}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTYZBM'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtyzbm}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTDH'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtdh}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTLXR'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtlxr}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTDZXX'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtdzxx}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTZYSRLY'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtzysrly}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='LJZJHCZ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.ljzjhcz}}
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 2">
                </div>
                <div v-else-if="ite.zdlx === 3">
                  <el-form-item v-if="ite.zdmc==='JTRK'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtrk}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTYSRJE'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtysrje}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JTNSRJE'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jtxx.jtnsrje}}
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 4">
                  <el-form-item v-if="ite.zdmc==='SFZJLXID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.sfzjlxbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XXID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xxbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='MZID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.mzbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='HYZKID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.hyzkbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XYZJID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xyzjbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='GATQWID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.gatqwbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JKZKID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.jkzkbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZZMMID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.zzmmbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='HKLBID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.hklbbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='GJDQID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.gjdqbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='HKXZ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.hkxzmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SYLX'" :label="ite.zdzwmc+'：'">
                    {{userInfo.sylx}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='RXQXL'" :label="ite.zdzwmc+'：'">
                    {{userInfo.rxqxl}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='CJLX'" :label="ite.zdzwmc+'：'">
                    {{userInfo.cjlx}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZXZT'" :label="ite.zdzwmc+'：'">
                    {{userInfo.zxztmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XSLBID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.xslbbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='RCPYFAID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.famc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SSXJXJHID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.ssxjxjhmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XQID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xqmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZYID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.zymc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='NJID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.njmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='BJID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.bjmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XZ'" :label="ite.zdzwmc+'：'">
                    <span v-for="(item, index) in xzData.list" :key="index">
                      <span v-if="userInfo.xsxj.xz === item.value">{{ item.label }}</span>
                    </span>
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XSDQZT'" :label="ite.zdzwmc+'：'">
                    <span v-if="userInfo.xsxj.xsdqzt">{{ userInfo.xsxj.xsdqzt.name }}</span>
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='LQJSID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.lqjsxm}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='RXFSID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.rxfsbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='XSLYID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.xslybt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='JDFSID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.jdfsbt}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZSZID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.zszmc}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='ZSJSID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.jsmc}}
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 5">
                  <el-form-item v-if="ite.zdmc==='CSDID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.csdsheng}}
                    <span v-if="userInfo.csdsheng && userInfo.csdshi">,</span>
                    {{userInfo.csdshi}}
                    <span v-if="userInfo.csdshi && userInfo.csdxian">,</span>
                    {{userInfo.csdxian}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='HKSZDXZQHID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.hkszdsheng}}
                    <span v-if="userInfo.hkszdsheng && userInfo.hkszdshi">,</span>
                    {{userInfo.hkszdshi}}
                    <span v-if="userInfo.hkszdshi && userInfo.hkszdxian">,</span>
                    {{userInfo.hkszdxian}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='LYDQID'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsly.lydqsheng}}
                    <span v-if="userInfo.xsly.lydqsheng && userInfo.xsly.lydqshi">,</span>
                    {{userInfo.xsly.lydqshi}}
                    <span v-if="userInfo.xsly.lydqshi && userInfo.xsly.lydqxian">,</span>
                    {{userInfo.xsly.lydqxian}}
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 6">
                  <el-form-item v-if="ite.zdmc==='XB'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xb}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SFJDLKPKH'" :label="ite.zdzwmc+'：'">
                    <span v-if="userInfo.sfjdlkpkh===true">是</span>
                    <span v-if="userInfo.sfjdlkpkh===false">否</span>
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SFCJ'" :label="ite.zdzwmc+'：'">
                    <span v-if="userInfo.sfcj===true">是</span>
                    <span v-if="userInfo.sfcj===false">否</span>
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SFYJS'" :label="ite.zdzwmc+'：'">
                    <span v-if="userInfo.sfyjs===true">是</span>
                    <span v-if="userInfo.sfyjs===false">否</span>
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='SFSLDRK'" :label="ite.zdzwmc+'：'">
                    <span v-if="userInfo.sfsldrk===true">是</span>
                    <span v-if="userInfo.sfsldrk===false">否</span>
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 7">
                </div>
                <div v-else-if="ite.zdlx === 8">
                  <el-form-item v-if="ite.zdmc==='CSRQ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.csrq}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='RTSJ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.rtsj}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='BMRQ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.bmrq}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='RXRQ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.rxrq}}
                  </el-form-item>
                  <el-form-item v-if="ite.zdmc==='LQRQ'" :label="ite.zdzwmc+'：'">
                    {{userInfo.xsxj.lqrq}}
                  </el-form-item>
                </div>
                <div v-else-if="ite.zdlx === 9">
                </div>
              </td>
            </tr>
          </table>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'
import { getXz, getXjzt } from '@/utils/meiju'

const props = defineProps({
  row: { type: Object, required: false }
})
const loading = ref(false)
const userInfo = ref({ jtcyList: [{}], jtxx: {}, xsly: {}, xsxj: {} })

const xzData = ref({ list: [] })
const xsdqztData = ref({ list: [] })
const bgData = ref([])
const hang = ref()
const lie = ref()

// 生成表格
const chaRuBiaoGe = (a, b) => {
  bgData.value = []
  for (let i = 0; i < a; i++) {
    const row = []
    for (let j = 0; j < b; j++) {
      row.push({ lzws: 1, sfbt: false, zdid: null, zdmc: null, zdlx: null, zdzwmc: null })
    }
    bgData.value.push(row)
  }
}
// 获取模板
const loadSubmit = () => {
  loading.value = true
  actionPost({ url: '/api/v2/pdp/biaodanxinximuban/1', data: {} }).then((res) => {
    if (res.code === 200) {
      if (res.data) {
        hang.value = res.data.hzws
        lie.value = res.data.lzws
        chaRuBiaoGe(hang.value, lie.value)
        bgData.value.forEach((bgItem, bgIndex) => {
          res.data.listShuXing.forEach((element, index) => {
            if (bgIndex === index) {
              bgItem.forEach((bgVal, bgInd) => {
                element.forEach((ele) => {
                  if (ele) {
                    if (ele.szwzhh === bgIndex + 1 && ele.szwzlh === bgInd + 1) {
                      bgVal.lzws = ele.lzws
                      bgVal.sfbt = ele.sfbt
                      bgVal.zdid = ele.zdid
                      bgVal.zdmc = ele.zdmc
                      bgVal.zdlx = ele.zdlx
                      bgVal.zdzwmc = ele.zdzwmc
                    }
                  }
                })
                for (let i = (bgInd + 1); i < (bgVal.lzws + bgInd); i++) {
                  bgItem.splice(bgInd + 1, 1)
                }
              })
            }
          })
        })
      } else {
        chaRuBiaoGe(hang.value, lie.value)
      }
      loading.value = false
    } else {
      loading.value = false
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.row,
  () => {
    if (props.row) {
      xzData.value = getXz()
      xsdqztData.value = getXjzt()
      loadSubmit()
      userInfo.value = props.row
      userInfo.value.rtsj = props.row.rtsj ? props.row.rtsj.substring(0, 10) : ''
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
.biao_ti {
  font-size: 21px;
}
:deep(.el-form-item) {
  margin: 0;
}
:deep(.el-form-item__label) {
  color: #606266 !important;
  font-weight: bold !important;
  padding: 0;
}
</style>
